import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const RecommendationsWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
`;

export const GridHeading = styled.div`
  margin-bottom: ${space[5]};
`;
